import { Input, Label } from '@kmgestao/ui';

import type { FormField } from '../../schemas.js';

export interface EmailFieldProps {
  field: FormField;
  value: string;
  onChange: (next: string) => void;
  onBlur?: (() => void) | undefined;
  error?: string | undefined;
  disabled?: boolean | undefined;
  idPrefix?: string | undefined;
}

/**
 * Campo de email. Diferença vs `TextField`: `type="email"` +
 * `inputmode="email"` + `autocomplete="email"` default + normaliza
 * para lowercase no blur (alinhado com `normalizeLeadInput`).
 */
export function EmailField({
  field,
  value,
  onChange,
  onBlur,
  error,
  disabled,
  idPrefix = 'form',
}: EmailFieldProps) {
  const inputId = `${idPrefix}-${field.id}`;
  const descId = field.description ? `${inputId}-desc` : undefined;
  const errorId = error ? `${inputId}-err` : undefined;

  return (
    <div className="space-y-2">
      <Label htmlFor={inputId}>
        {field.label}
        {field.required ? <span className="ml-0.5 text-destructive"> *</span> : null}
      </Label>
      {field.description ? (
        <p id={descId} className="text-xs text-muted-foreground">
          {field.description}
        </p>
      ) : null}
      <Input
        id={inputId}
        type="email"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => {
          // Lowercase + trim no blur (padrão do sistema)
          const normalized = value.trim().toLowerCase();
          if (normalized !== value) onChange(normalized);
          onBlur?.();
        }}
        placeholder={field.placeholder ?? 'nome@empresa.com.br'}
        autoComplete={field.autocomplete ?? 'email'}
        inputMode="email"
        hasError={!!error}
        disabled={disabled}
        aria-describedby={[descId, errorId].filter(Boolean).join(' ') || undefined}
        aria-invalid={!!error}
      />
      {error ? (
        <p id={errorId} className="text-sm text-destructive" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
